"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dayjs = exports.isPartialDay = exports.getDateValidationFormat = void 0;
exports.currentTimezone = currentTimezone;
exports.convertFormatToMoment = convertFormatToMoment;
exports.momentDate = momentDate;
exports.formatDate = formatDate;
exports.getFormattedDateSetting = getFormattedDateSetting;
exports.getDayFormat = getDayFormat;
exports.getDateSetting = getDateSetting;
const dayjs_1 = __importDefault(require("dayjs"));
exports.dayjs = dayjs_1.default;
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const advancedFormat_1 = __importDefault(require("dayjs/plugin/advancedFormat"));
const customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
const lodash_1 = require("lodash");
const Evaluator_1 = require("./Evaluator");
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
dayjs_1.default.extend(advancedFormat_1.default);
dayjs_1.default.extend(customParseFormat_1.default);
/**
 * Get the current timezone string.
 *
 * @return {string}
 */
function currentTimezone() {
    return dayjs_1.default.tz.guess();
}
/**
 * Convert the format from the angular-datepicker module to moment format.
 * @param format
 * @return {string}
 */
function convertFormatToMoment(format) {
    return (format
        // Year conversion.
        .replace(/y/g, 'Y')
        // Day in month.
        .replace(/d/g, 'D')
        // Day in week.
        .replace(/E/g, 'd')
        // AM/PM marker
        .replace(/a/g, 'A')
        // Unix Timestamp
        .replace(/U/g, 'X'));
}
/**
 * Get the moment date object for translating dates with timezones.
 *
 * @param value
 * @param format
 * @param timezone
 * @return {*}
 */
function momentDate(value, format, timezone) {
    const momentDate = (0, dayjs_1.default)(value);
    if (timezone === 'UTC') {
        return dayjs_1.default.utc();
    }
    if (timezone !== currentTimezone() || (format && format.match(/\s(z$|z\s)/))) {
        return momentDate.tz(timezone);
    }
    return momentDate;
}
/**
 * Format a date provided a value, format, and timezone object.
 *
 * @param value
 * @param format
 * @param timezone
 * @return {string}
 */
function formatDate(value, format, timezone) {
    const date = (0, dayjs_1.default)(value);
    const dayjsFormat = convertFormatToMoment(format);
    if (timezone === 'UTC') {
        return `${date.utc().format(dayjsFormat)} UTC`;
    }
    if (timezone) {
        return date.tz(timezone).format(`${dayjsFormat} z`);
    }
    return date.format(dayjsFormat);
}
function getFormattedDateSetting(date, component, timezone) {
    var _a;
    return formatDate(date, ((_a = component.widget) === null || _a === void 0 ? void 0 : _a.format) || 'yyyy-MM-dd hh:mm a', timezone || currentTimezone());
}
function getDayFormat(component) {
    let format = '';
    const showDay = !(0, lodash_1.get)(component, 'fields.day.hide', false);
    const showMonth = !(0, lodash_1.get)(component, 'fields.month.hide', false);
    const showYear = !(0, lodash_1.get)(component, 'fields.year.hide', false);
    if (component.dayFirst && showDay) {
        format += 'D/';
    }
    if (showMonth) {
        format += 'M/';
    }
    if (!component.dayFirst && showDay) {
        format += 'D/';
    }
    if (showYear) {
        format += 'YYYY';
        return format;
    }
    else {
        // Trim off the "/" from the end of the format string.
        return format.length ? format.substring(0, format.length - 1) : format;
    }
}
/**
 * Return a translated date setting.
 *
 * @param date
 * @return {(null|Date)}
 */
function getDateSetting(date) {
    if ((0, lodash_1.isNil)(date) || (0, lodash_1.isNaN)(date) || date === '') {
        return null;
    }
    if (date instanceof Date) {
        return date;
    }
    else if (typeof date.toDate === 'function') {
        return date.isValid() ? date.toDate() : null;
    }
    let dateSetting = typeof date !== 'string' || date.indexOf('moment(') === -1 ? (0, dayjs_1.default)(date) : null;
    if (dateSetting && dateSetting.isValid()) {
        return dateSetting.toDate();
    }
    dateSetting = null;
    try {
        const value = Evaluator_1.Evaluator.evaluator(`return ${date};`, 'moment')(dayjs_1.default);
        if (typeof value === 'string') {
            dateSetting = (0, dayjs_1.default)(value);
        }
        else if (typeof value.toDate === 'function') {
            dateSetting = (0, dayjs_1.default)(value.toDate().toUTCString());
        }
        else if (value instanceof Date) {
            dateSetting = (0, dayjs_1.default)(value);
        }
    }
    catch (ignoreError) {
        return null;
    }
    if (!dateSetting) {
        return null;
    }
    // Ensure this is a date.
    if (!dateSetting.isValid()) {
        return null;
    }
    return dateSetting.toDate();
}
const getDateValidationFormat = (component) => {
    return component.dayFirst ? 'DD-MM-YYYY' : 'MM-DD-YYYY';
};
exports.getDateValidationFormat = getDateValidationFormat;
const isPartialDay = (component, value) => {
    if (!value) {
        return true;
    }
    const [DAY, MONTH, YEAR] = component.dayFirst ? [0, 1, 2] : [1, 0, 2];
    const values = value.split('/');
    return values[DAY] === '00' || values[MONTH] === '00' || values[YEAR] === '0000';
};
exports.isPartialDay = isPartialDay;
